import {
	type CommonProps,
	type ILogForwarder,
	type LogEntry,
	LogLevel,
	type LogMessage,
	type LogMetadata,
	type LogType,
} from "../types";

export class ConsoleLogger implements ILogForwarder {
	protected transformLog(
		type: LogType,
		level: LogLevel,
		injectedProps: CommonProps,
		message: LogMessage,
		...metadata: LogMetadata[]
	): LogEntry {
		let entry: LogEntry = {
			level: LogLevel[level],
			type,
		};

		if (typeof message === "string") {
			entry.message = message;
		} else if (typeof message === "object") {
			entry = { ...entry, ...message };
		} else {
			entry.message = String(message);
		}

		if (metadata?.length > 0) {
			entry.metadata = metadata;
		}

		entry = {
			...entry,
			...injectedProps,
		};

		return entry;
	}

	log(
		type: LogType,
		level: LogLevel,
		injectedProps: CommonProps,
		message: LogMessage,
		...metadata: LogMetadata[]
	): void {
		const entry = this.transformLog(type, level, injectedProps, message, ...metadata);
		this.logEntry(entry);
	}

	logEntry = (entry: LogEntry) => console.log(`${entry.level}: ${entry.message ?? entry.action}`, entry);
}
